module.exports = __webpack_public_path__ + "img-dashboard/register/check.20a578d0.png";